// Fontawesome 5
import './shared/font-awesome';

// Style
import '../scss/app.scss';

// App Config
import AppConfig from './app.config';


// App Controller
const AppController = require('./app.controller');

// App Filters
const RelativeDate = require('./shared/filters/RelativeDate');
const PriceSeperator = require('./shared/filters/PriceSeperator');
const limitText = require('./shared/filters/limitText');


// Auth
const authHttpResponseInterceptor = require('./shared/auth/authHttpResponseInterceptor');


// ImportExternalComponentJS
import headerComponent from '../../Sooran.FrontTinet.ClientShare/Header/header.component';

// ImportExternalModuleJS
import MailingModule from "../../Sooran.FrontTinet.Mailing/Mailing.module";
import WalletModule from "../../Sooran.FrontTinet.Wallet/Wallet.module";
import NoticesModule from "../../Sooran.FrontTinet.Notices/Notices.module";

// ImportModuleJS
import SettingModule from "./components/Setting/Setting.module";
import GraphsModule from "./components/Graphs/Graphs.module";
import LancerifyModule from "./components/Lancerify/Lancerify.module";
import CompanyRoleModule from "./components/CompanyRole/CompanyRole.module";
import CoWorkModule from "./components/CoWork/CoWork.module";
import AloBizModule from "./components/AloBiz/AloBiz.module";
import AcceleratorModule from "./components/Accelerator/Accelerator.module";
import DepartmentModule from "./components/Department/Department.module";
import StormModule from "./components/Storm/Storm.module";
import TendersModule from "./components/Tenders/Tenders.module";
import BusinessServiceModule from "./components/BusinessService/BusinessService.module";
import IdeaModule from "./components/Idea/Idea.module";
import GeneralInfoModule from "./components/GeneralInfo/GeneralInfo.module";
import DashboardModule from "./components/Dashboard/Dashboard.module";
import JoorpinModule from "./components/Joorpin/Joorpin.module";

import AppRun from './app.run';



/**
 * @api {get} /user/:id Request User information
 * @apiName GetUser
 * @apiGroup User
 * @apiDeprecated use now (#Group:Name).  
 * @apiDescription This is the Description.
 * @apiParam {Number} id Users unique ID.
 *
 * @apiSuccess {String} firstname Firstname of the User.
 * @apiSuccess {String} lastname  Lastname of the User.
 */


const ngModule = angular
    .module("app", [

        /* Shared modules */
        "ui.router",
        "oc.lazyLoad",
        "ngResource",
        "ngMaterial",
        "ngMessages",
        "ngAnimate",
        'ADM-dateTimePicker',
        "angular-loading-bar",
        "ngTable",
        "cgBusy",
        "angular-3d-carousel",
        "angularPromiseButtons",
        "ngOidc",
        'ngFileUpload',
        "angularPagination",
        "ngCookies",
        "dndLists",

        /* Feature areas*/
        "MailingModule",
        "GraphsModule",
        "LancerifyModule",
        "CompanyRoleModule",
        "CoWorkModule",
        "AloBizModule",
        "JoorpinModule",
        "NoticesModule",
        "SettingModule",
        "AcceleratorModule",
        "DepartmentModule",
        "StormModule",
        "TendersModule",
        "BusinessServiceModule",
        "WalletModule",
        "angular-intro",
        "IdeaModule",
        "GeneralInfoModule",
        "DashboardModule",
        "oc.lazyLoad"

    ]);


ngModule.config(AppConfig);
ngModule.run(AppRun);

// Inject Components
headerComponent(ngModule)

AppController(ngModule);
RelativeDate(ngModule);
PriceSeperator(ngModule);
limitText(ngModule);
authHttpResponseInterceptor(ngModule);

// FormatDate Directive
require('./shared/filters/FormatDate')(ngModule);

// currencyInput Directive
require('./shared/Directive/currencyInput')(ngModule);

// checkImage Directive
require('./shared/Directive/checkImage')(ngModule);

// numbersOnly Directive
require('./shared/Directive/numbersOnly')(ngModule);

export {
    ngModule
};
